export default __webpack_public_path__ + "static/media/spring-news.e9140dba.jpg";